export let optionTitle_templates = "$Ccsnb";
export let optionSearchTerms_templates = "oHUgZb";
export default {optionTitle_templates,optionSearchTerms_templates};